import { Option, Label, Remove } from './styles'

Option.Label = Label
Option.Remove = Remove

export default Option
